
export const Footer = () => {
  return (
    <footer className="text-xs text-center pt-12 animate-fadeIn">
      <p className="opacity-50">Made with React JS and TypeScript</p>
      <a
        href="https://me.carlosc.dev"
        target="_blank"
        rel="noreferrer noopener"
        className="text-cyan-500 font-semibold"
      >
          @carloscdev
      </a>
    </footer>
  )
}
